
import Orm from '@/store/plugins/orm/Orm';
import * as mutationTypes from '@/store/mutationTypes';

const toCamelCase = (s) => {
    return s.replace(/([-_][a-z])/ig, ($1) => {
      return $1.toUpperCase()
        .replace('-', '')
        .replace('_', '');
    });
};

// Save the entire state to memory on every change
export default store => {
    store.subscribe((m, state) => {
        if(m.payload.init) return

        const ignoredMutations = [
            mutationTypes.SET_IS_ONLINE,
            mutationTypes.SET_LOCAL_CONNECTION,
            mutationTypes.SET_SYNC_IN_PROGRESS,
            mutationTypes.SET_SYNC_OPTIONS,
            mutationTypes.SET_IMPERSONATE,
            mutationTypes.SET_INITIALIZED,
            mutationTypes.SET_TRAINING_MODE,
            mutationTypes.SET_TABLE_MODE,
            mutationTypes.SET_ACTIVE_SECTOR,
        ]

        if(ignoredMutations.includes(m.type)) return

        if(m.type.includes(Orm.namespace + '/')) {
            AppStorage.store().setItem(Orm.namespace + '.' + m.payload.model.entity, JSON.stringify(state[Orm.namespace][m.payload.model.entity].data));
        } else if(m.type.includes('SET_')) {
            const stateProperty = toCamelCase(m.type.replace('SET_', '').toLowerCase())
            AppStorage.store().setItem(stateProperty, JSON.stringify(state[stateProperty]))
        }
    });
};
